<ion-header class="ion-padding-start shadow-none ion-no-margin bg-transparent">
  <ion-toolbar class="ion-no-padding">
    <ion-text class="page-title ion-no-margin font-family-bold pb-0">
      {{'VEHICLE_ORDERING_INFORMATION' | translate}}
    </ion-text>
    <ion-buttons slot="end">
      <ion-button (click)="close()" (keydown.escape)="close()" aria-label="Close">
        <ion-icon name="close-outline" aria-hidden="true"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
    @if (showValidationError() || showDriverValidationMessage()) {
<div class="validation-section">

  @if (showValidationError()) {
  <ion-text class="text-danger-accent">
    {{'VALIDATION_MESSAGE_VEHICLE_ORDERING_INFORMATION' | translate}}
  </ion-text>
  }

  @if (showDriverValidationMessage()) {
  <ion-text class="validation-message primary">
    {{ getDriverAcceptanceUpdateMessage() }}
  </ion-text>
  }

</div>
}
</ion-header>

<ion-content class="ion-padding">

  @if (loadFailed()) {
  <div class="ion-padding">
    <ion-text class="text-danger-accent">
      {{'ERROR_LOADING_VEHICLE_ORDER_POLICY' | translate}}
    </ion-text>
  </div>
  }

  @if(voiList().length>0)
  {
  @for (item of voiList(); track item.vehicleOrderingPolicyId)
  {
  <!-- TEXT CONTENT -->
  @if (item.contentType.includes('TEXT'))
  {
  <div class="pre-line-text">
    <p>{{ item.contentText }}</p>
  </div>
  }

  <!-- URL CONTENT -->
  @if (item.contentType.includes('URL') && item.contentUrl)
  {
  <div class="ion-margin-bottom">
    <a [href]="item.contentUrl" target="_blank" rel="noopener noreferrer">
      {{'OPEN_LINK' | translate}}
    </a>
  </div>
  }
  }
  }
  <!--CHECKBOX CONTROLLED BY BACKEND -->
  @if (showCheckBox())
  {
  <ion-checkbox labelPlacement="end" [ngModel]="isChecked()" [class.readonly]="!isCheckboxEnabled()"
    (ionChange)="onCheckboxChange($event)">
    {{'CHECKBOX_MESSAGE_VEHICLE_ORDERING_INFORMATION' | translate}}
  </ion-checkbox>

  <ion-text>
    {{'RECORD_MESSAGE_VEHICLE_ORDERING_INFORMATION' | translate}}
  </ion-text>

  }
</ion-content>